import React from "react";

export class ErrorBoundary extends React.Component<{children: React.ReactNode}, {hasError: boolean}> {
  constructor(props: {children: React.ReactNode}) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {
    // log error if you want
  }
  render() {
    if (this.state.hasError) {
      return <div style={{color: "red"}}>Could not render model preview.</div>;
    }
    return this.props.children;
  }
}